import { Icon, Popover, PopoverProps } from '@leroy-merlin-br/backyard-react'
import { PropsWithChildren, useEffect, useState } from 'react'
import { Cross } from '@leroy-merlin-br/backyard-icons'

import * as S from './styled'

const Tooltip = ({ children }: PropsWithChildren<PopoverProps>) => {
  const [visible, setVisible] = useState(false)
  const [vanishing, setVanishing] = useState(true)

  useEffect(() => {
    setTimeout(() => setVisible(true), 1000)
    setTimeout(() => setVisible(false), 15000)
    return () => {
      setVisible(false)
    }
  }, [setVisible])

  return (
    <Popover
      visible={visible}
      trigger={undefined}
      interactive
      animation
      onHide={(instance) => {
        const box = instance.popper
        if (!vanishing) {
          requestAnimationFrame(instance.unmount)
          return
        }

        box.classList.add('to-hide')
        setTimeout(() => {
          requestAnimationFrame(instance.unmount)
        }, 2000)
      }}
      placement="top-start"
      content={
        <S.PopoverContent data-testid="tooltip-content">
          <S.CloseButton
            data-testid="closes"
            onClick={() => {
              setVanishing(false)
              setVisible(false)
            }}
          >
            <Icon as={Cross} size="byte" />
          </S.CloseButton>
          Olá, sou a assistente virtual da Leroy Merlin e posso te ajudar com os
          produtos que deseja.
        </S.PopoverContent>
      }
    >
      {children}
    </Popover>
  )
}

export default Tooltip
